import { render, staticRenderFns } from "./AbandonedIndex.vue?vue&type=template&id=0f8aadd1&"
import script from "./AbandonedIndex.vue?vue&type=script&lang=js&"
export * from "./AbandonedIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports